import { Avatar, Flex, Text } from '@chakra-ui/react'
import { FaRegCalendarAlt } from 'react-icons/fa'
import { useNavigate } from 'react-router-dom'
import { ButtonCmp } from '../../../../../components/ButtonCmp'
import { formatarData } from '../../../../../Utils/Helper'
import { iConvitePesquisa } from '../../interfaces'

interface iProps {
  convite: iConvitePesquisa
}

export const CardPesquisa: React.FC<iProps> = ({ convite }) => {
  const nav = useNavigate()

  function DiasRestantes(): number {
    const fim = new Date(convite.dataTermino.split('T')[0])
    const hoje = new Date(new Date().toISOString().split('T')[0])
    return Math.ceil((fim.getTime() - hoje.getTime()) / (1000 * 60 * 60 * 24))
  }

  function ObterNota(): string {
    const dias = DiasRestantes()
    if (dias < 0) return 'Prazo encerrado'
    if (dias === 0) return 'Encerra hoje'
    if (dias === 1) return 'Encerra amanhã'
    if (dias <= 3) return `Encerra em ${dias} dias`
    return `Faltam ${dias} dias para o encerramento`
  }

  return (
    <Flex
      flexDir={'column'}
      justifyContent={'space-between'}
      gap={'.875rem'}
      bg={'var(--c1)'}
      borderRadius={'.25rem'}
      boxShadow={'var(--SombraBackground)'}
      padding={'1.125rem 1rem'}
    >
      <Flex flexDir={'column'} gap={'.75rem'}>
        <Text fontSize={'.925rem'} fontWeight={'700'} lineHeight={'1.25rem'} color={'var(--Gray1)'}>
          {convite.pesquisaNome}
        </Text>

        <Flex alignItems={'center'} gap={'.625rem'}>
          <Avatar size={'sm'} name={convite.avaliado} src={convite.avatar} />
          <Flex flexDir={'column'} minW={0}>
            <Text fontSize={'.75rem'} color={'var(--Gray3)'} lineHeight={'1rem'}>Avaliado</Text>
            <Text fontSize={'.875rem'} fontWeight={'700'} color={'var(--Gray1)'} lineHeight={'1.125rem'} noOfLines={2}>
              {convite.avaliado}
            </Text>
          </Flex>
        </Flex>

        <Flex alignItems={'center'} gap={'.4375rem'} fontSize={'.8125rem'} color={'var(--Azul)'}>
          <FaRegCalendarAlt size={13} />
          <Text>{formatarData(convite.dataEnvio)} a {formatarData(convite.dataTermino)}</Text>
        </Flex>
      </Flex>

      <Flex flexDir={'column'} gap={'.5rem'}>
        <ButtonCmp
          VarColor='Green2'
          w={'100%'}
          h={['2.75rem', '2.4rem']}
          fontSize={'16px'}
          onClick={() => nav(`/Abertura/${convite.tokenId}`)}
        >Responder pesquisa</ButtonCmp>

        <Text fontSize={'.75rem'} color={DiasRestantes() <= 3 ? 'var(--Rosa)' : 'var(--Gray4)'}>
          {ObterNota()}
        </Text>
      </Flex>
    </Flex>
  )
}
